import { ApplicationConfig, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { GuestTokenService } from './service/guest-token.service';
import { authInterceptor } from './service/auth.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';

import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// import { GuestTokenService } from './services/guest-token.service'; // ⬅️ import your service

// ⬅️ factory function for APP_INITIALIZER
export function initGuestToken(guestTokenService: GuestTokenService) {
  const platformId = inject(PLATFORM_ID);

  return () => {
    // 🚫 Skip API call during SSR
    if (!isPlatformBrowser(platformId)) {
      return Promise.resolve(true);
    }

    // ✅ Run only in browser
    return guestTokenService.fetchGuestToken();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',          // ✅ REQUIRED
        scrollPositionRestoration: 'enabled' // ✅ recommended
      })
    ),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideNativeDateAdapter(),
    // ✅ add initializer here
    {
      provide: APP_INITIALIZER,
      useFactory: initGuestToken,
      deps: [GuestTokenService],
      multi: true
    }
  ]
};
